import type { RequestStatus } from "@albertine/types";
import type {
    RequestAiCaptureStatus,
    RequestHighlightedFields,
} from "../../common/types/Request";

export interface CaptureViewInput {
    aiCaptureStatus: RequestAiCaptureStatus | null | undefined;
    highlightedFields: RequestHighlightedFields | null | undefined;
    status: RequestStatus;
}

export interface CaptureView {
    isAnalysing: boolean;
    isFailed: boolean;
    showAiReview: boolean;
}

export function deriveCaptureView({
    aiCaptureStatus,
    highlightedFields,
    status,
}: CaptureViewInput): CaptureView {
    const isAnalysing = aiCaptureStatus === "analysing";
    const isFailed = aiCaptureStatus === "failed";
    const isUnopened = status === "draft" || status === "new";
    const hasAiCapturedDetails =
        aiCaptureStatus === "complete" && (highlightedFields?.length ?? 0) > 0;

    return {
        isAnalysing,
        isFailed,
        showAiReview: hasAiCapturedDetails && isUnopened,
    };
}
